import { EmptyState, Spinner, theme, Icon, TabSegmented, TabSegmentedGroup } from '@ketch-com/deck'
import { Box, Typography } from '@mui/material'
import { useDataSentryContext } from 'pages/dataSentry/context/DataSentryContext'
import { MostSeenTrackerItem } from './MostSeenTrackerItem'
import {
  AuthorizationStatus as TrackerAuthorizationStatus,
  ControlStatus as TrackerControlStatus,
} from '@ketch-com/windlass/dist/dataSentry/v1/trackers/trackers'

export const MostSeenTrackers: React.FC = () => {
  const {
    mostSeenTrackers,
    mostSeenTrackersLoading,
    mostSeenTrackersAuthorizationStatus,
    setMostSeenTrackersAuthorizationStatus,
    mostSeenTrackersControlStatus,
    setMostSeenTrackersControlStatus,
  } = useDataSentryContext()

  const isLoadingMostSeenTrackers = mostSeenTrackersLoading
  const displayMostSeenTrackersEmptyState = !isLoadingMostSeenTrackers && !mostSeenTrackers?.length
  const displayMostSeenTrackers = !isLoadingMostSeenTrackers && mostSeenTrackers?.length

  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="column"
      gap={2}
      sx={{ backgroundColor: theme.palette.Common.Container }}
      borderRadius="11px"
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" px={2.5} pt={2} pb={1}>
        <Typography variant="h4">Most Seen Trackers</Typography>
        <Box display="flex" alignItems="center" gap={1}>
          {mostSeenTrackersAuthorizationStatus === TrackerAuthorizationStatus.AUTHORIZED ? (
            <TabSegmentedGroup
              size="small"
              value={mostSeenTrackersControlStatus}
              exclusive
              onChange={(_, value) => {
                setMostSeenTrackersControlStatus?.(value)
              }}
            >
              <TabSegmented value={TrackerControlStatus.UNSPECIFIED}>
                <Box display="flex" gap={0.5} alignItems="center">
                  <Typography variant="label">Overall</Typography>
                </Box>
              </TabSegmented>
              <TabSegmented value={TrackerControlStatus.CONTROLLED}>
                <Box display="flex" gap={0.5} alignItems="center">
                  <Typography variant="label">Controlled</Typography>
                </Box>
              </TabSegmented>
              <TabSegmented value={TrackerControlStatus.UNCONTROLLED}>
                <Box display="flex" gap={0.5} alignItems="center">
                  <Typography variant="label">Uncontrolled</Typography>
                </Box>
              </TabSegmented>
            </TabSegmentedGroup>
          ) : null}
          <TabSegmentedGroup
            size="small"
            value={mostSeenTrackersAuthorizationStatus}
            exclusive
            onChange={(_, value) => {
              setMostSeenTrackersAuthorizationStatus?.(value)
            }}
          >
            <TabSegmented value={TrackerAuthorizationStatus.AUTHORIZED}>
              <Box display="flex" gap={0.5} alignItems="center">
                <Typography variant="label">Authorized</Typography>
              </Box>
            </TabSegmented>
            <TabSegmented value={TrackerAuthorizationStatus.UNAUTHORIZED}>
              <Box display="flex" gap={0.5} alignItems="center">
                <Typography variant="label">Unauthorized</Typography>
              </Box>
            </TabSegmented>
          </TabSegmentedGroup>
        </Box>
      </Box>

      <Box display="flex" justifyContent="center" gap={8} py={4} flexWrap="wrap" width={780} margin="auto">
        {isLoadingMostSeenTrackers ? (
          <Box display="flex" justifyContent="center" alignItems="center" width="100%">
            <Spinner size="32px" thickness={2.5} />
          </Box>
        ) : null}

        {displayMostSeenTrackersEmptyState ? (
          <Box display="flex" justifyContent="center" alignItems="center" width="100%">
            <EmptyState
              size="small"
              colorTheme={theme.palette.Text.Secondary}
              customIcon={<Icon name="FShapes" width="48px" height="48px" iconColor={theme.palette.Black.o48} />}
              title="No Data"
              subTitle="Review your settings and connections, or wait for the scan to finish processing."
            />
          </Box>
        ) : null}

        {displayMostSeenTrackers
          ? mostSeenTrackers.map(trackerProps => <MostSeenTrackerItem {...trackerProps} />)
          : null}
      </Box>
    </Box>
  )
}
